import { render, staticRenderFns } from "./FetchService.vue?vue&type=template&id=77b8b548&scoped=true"
import script from "./FetchService.vue?vue&type=script&lang=js"
export * from "./FetchService.vue?vue&type=script&lang=js"
import style0 from "./FetchService.vue?vue&type=style&index=0&id=77b8b548&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b8b548",
  null
  
)

export default component.exports